import { RowsPlaceholder } from "./RowsPlaceholder";
import { containerEvents } from "../../ContainerEvents"
import { graphicEvents, ON_PLACEHOLDER_ONE_ROW_ONE_SEAT, CREATE_ENTITIES, CREATE_ROWS } from "../../GraphicEvents";
import { RowService } from "../../entity/row/RowService";
import { stateManager } from "../../StateManager";

export class RowEditionMode {

    constructor() {
        this.rowsPlaceholder = new RowsPlaceholder();

        this.onCreateRows = this.onCreateRows.bind(this);
        graphicEvents.on(CREATE_ROWS, this.onCreateRows);
    }

    onCreateRows({ count }) {
        this.rowsPlaceholder.drawItems(count);

        const rows = this.rowsPlaceholder.getStatement().reverse();

        RowService.changeLabelMultipleRows({
            rows: rows,
            value: count.startLabel
        });
        this.rowsPlaceholder.rows = rows.reverse();

        this.onFinishClick();
    }

    onStartClick() {
        this.rowsPlaceholder.start(containerEvents.mouseCoords);
    }

    onFinishClick() {
        const rows = this.rowsPlaceholder.getStatement();

        if (!rows.length) {
            graphicEvents.trigger(ON_PLACEHOLDER_ONE_ROW_ONE_SEAT);
        } else {
            graphicEvents.trigger(CREATE_ENTITIES, rows);
        }

        this.rowsPlaceholder.stop();
    }

    onCancelClick() {
        this.rowsPlaceholder.stop();
    }

    onMoveMouse() {
        this.rowsPlaceholder.move(containerEvents.mouseCoords);
    }

    destroy() {
        this.rowsPlaceholder.destroy();
        graphicEvents.remove(CREATE_ROWS, this.onCreateRows);
    }
}